import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { jobsService } from '../jobsService';
import { IGetJobsParams, IJob } from '../types/jobsTypes';

type TUseInfiniteJobsParams = Omit<IGetJobsParams, 'page'> & {
  enabled?: boolean;
};

export function useInfiniteJobs(params: TUseInfiniteJobsParams) {
  const query = useInfiniteQuery<IJob[]>({
    queryKey: ['jobs-infinite', params],
    queryFn: ({ pageParam }) =>
      jobsService.getJobs({
        ...params,
        page: pageParam as number,
      }),
    getNextPageParam: (lastPage, allPages) => {
      // If less than limit returned, no more pages
      return lastPage.length === params.limit ? allPages.length + 1 : undefined;
    },
    enabled: params.enabled ?? true,
    staleTime: 1000 * 30, // 30 seconds
    gcTime: 1000 * 60 * 2, // 2 minutes
    initialPageParam: 1,
  });

  const jobs = useMemo(() => query?.data?.pages.flatMap((page) => page) ?? [], [query.data?.pages]);

  return {
    jobs: jobs ?? [],
    ...query,
  };
}
